import React from "react";
import { IconButton, Stack, Button, Chip, Tooltip } from "@mui/material";
import { AddNewButton, FeatureHeader } from "../../../components-new";
import { observer } from "mobx-react-lite";
import { useNavigate, useParams } from "react-router";
import { useStore } from "../../../helpers";
import { useTranslation } from "react-i18next";
import { ViewToggle } from "./view-toggle";

interface ServiceRequestHeaderProps {
    showMyRequests: boolean;
    onToggleMyRequests: (value: boolean) => void;
    viewMode: "card" | "table";
    onViewChange: (view: "card" | "table") => void;
}

export const ServiceRequestHeader = observer(
    ({
        showMyRequests,
        onToggleMyRequests,
        viewMode,
        onViewChange,
    }: ServiceRequestHeaderProps) => {
        const navigate = useNavigate();
        const rootStore = useStore();
        const { serviceRequestsStore } = rootStore;
        const { projectid } = useParams();
        const { t } = useTranslation("service_request_home");

        return (
            <Stack
                direction="row"
                justifyContent="space-between"
                className="w-full mb-6"
            >
                <div className="w-full flex flex-col md:flex-row md:justify-between md:items-center gap-4">
                    {/* Title */}
                    <div className="flex items-center gap-3">
                        <FeatureHeader title={t("sr_title")} />
                        {showMyRequests && (
                            <Chip
                                label="My Requests"
                                size="small"
                                color="primary"
                                className="hidden md:inline-flex"
                            />
                        )}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-row items-center gap-2 md:gap-3">
                        {/* View Toggle - Desktop only */}
                        <div className="hidden md:block">
                            <ViewToggle
                                view={viewMode}
                                onChange={onViewChange}
                            />
                        </div>

                        {/* My Requests Toggle */}
                        {/*<Button*/}
                        {/*    variant={showMyRequests ? "contained" : "outlined"}*/}
                        {/*    size="small"*/}
                        {/*    onClick={() => {*/}
                        {/*        const newValue = !showMyRequests;*/}
                        {/*        onToggleMyRequests(newValue);*/}
                        {/*        const query = newValue ? "?mode=my" : "";*/}
                        {/*        navigate(`/project/${projectid}/servicerequests${query}`);*/}
                        {/*    }}*/}
                        {/*    sx={{*/}
                        {/*        textTransform: "none",*/}
                        {/*        borderRadius: "8px",*/}
                        {/*        fontWeight: 600,*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    {showMyRequests ? t("back_to_all_requests") : t("my_requests")}*/}
                        {/*</Button>*/}

                        {/* Settings */}
                        <Tooltip title="Manage Settings">
                            <IconButton
                                size="small"
                                onClick={() => navigate("manage")}
                                sx={{
                                    border: "1px solid #E5E7EB",
                                    borderRadius: "8px",
                                    "&:hover": {
                                        backgroundColor: "#F3F4F6",
                                    },
                                }}
                            >
                                <i className="fas fa-cog text-gray-700" />
                            </IconButton>
                        </Tooltip>

                        {/* Mobile Filter */}
                        <div className="block md:hidden">
                            <IconButton
                                size="small"
                                onClick={() =>
                                    serviceRequestsStore.setServiceFilter(true)
                                }
                                sx={{
                                    border: "1px solid #E5E7EB",
                                    borderRadius: "8px",
                                    "&:hover": {
                                        backgroundColor: "#F3F4F6",
                                    },
                                }}
                            >
                                <i className="fas fa-sliders-h text-gray-700" />
                            </IconButton>
                        </div>
                    </div>
                </div>
            </Stack>
        );
    }
);
